import React from 'react'
import logo from '../../images/logo-games.webp'
import {Navbar, Container, Nav} from 'react-bootstrap'
import{BsHeart, BsCart, BsSearch} from 'react-icons/bs'
import{BiUser} from 'react-icons/bi'

import {  NavLink } from "react-router-dom";





export default function Header() {
  return (
    

<Navbar className="stickynav" collapseOnSelect expand="lg"  >
  <Container fluid>
  <Navbar.Brand > <NavLink to=""><img src={logo} className="img-fluid" alt="logo"/></NavLink></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="ms-auto me-auto">


 
          
              <NavLink to="">Home</NavLink>
           
              <NavLink to="/about">About</NavLink>
          
              <NavLink to="/shop">Shop</NavLink>
          
            
              <NavLink to="/contact">Contact us</NavLink>
            


        


     

      
      
   
    </Nav>


    

    <div className="custom-links">
      <ul className="dropn">
      <li ><BsSearch/> </li>
         <li ><BsHeart/> </li>
         <li ><BiUser/> </li>
         <li ><BsCart/> </li>
         
      </ul>

    </div>
   
  </Navbar.Collapse>
  </Container>
</Navbar>


  )
}
